import FlightCard from './FlightCard';
export default FlightCard;
